import {Action, Store} from 'redux';

import {getCalculatedRoute, getRoute} from 'config/navigation';
import {CHECK_TIMEOUT, RESET_TIMEOUT, showTimeoutWarning} from 'ducks/SessionActivity';
import {getLastActivityTimestamp} from 'selectors/sessionActivity';
import {
  TIMEOUT_WARNING_MINUTES,
  MINUTE_MS,
  TIMEOUT_LOGOUT_MINUTES,
  terminateUnauthenticatedSession
} from 'shared/utils/session';

const getSessionTimeoutRoute = () => {
  switch (true) {
    case window.location.pathname.includes(getRoute('/express-id')):
    case window.location.pathname.includes(getRoute('/quoting')):
    case window.location.pathname.includes(getRoute('/pay-as-guest')):
    case window.location.pathname.includes(getRoute('/photo-upload/home')):
    case window.location.pathname.includes(getRoute('/claims/fnol/prelogin')):
    case window.location.pathname.includes(getRoute('/claims/prelogin/upload')):
      return getCalculatedRoute('timeout');
    default:
      return undefined;
  }
};

let sessionTimeoutWarningTimer: number;
const resetSessionTimeoutWarning = (store: Store) => {
  if (sessionTimeoutWarningTimer) {
    window.clearTimeout(sessionTimeoutWarningTimer);
  }
  sessionTimeoutWarningTimer = window.setTimeout(() => {
    store.dispatch(showTimeoutWarning());
  }, TIMEOUT_WARNING_MINUTES * MINUTE_MS);
};

let sessionTimeoutLogoutTimer: number;
const resetSessionTimeoutLogout = () => {
  if (sessionTimeoutLogoutTimer) {
    window.clearTimeout(sessionTimeoutLogoutTimer);
  }
  sessionTimeoutLogoutTimer = window.setTimeout(async () => {
    const unathenticatedSessionTimeoutroute = getSessionTimeoutRoute();
    if (unathenticatedSessionTimeoutroute) {
      terminateUnauthenticatedSession(unathenticatedSessionTimeoutroute);
    } else {
      const oktaClient = await import('shared/utils/okta/okta-client');

      await oktaClient.logout();
    }
  }, TIMEOUT_LOGOUT_MINUTES * MINUTE_MS);
};

const sessionActivity = (store: Store) => (next: (action: Action) => object) => (action: Action) => {
  const prevState = store.getState();
  const result = next(action);
  const newState = store.getState();

  if (action.type === RESET_TIMEOUT) {
    resetSessionTimeoutWarning(store);
    resetSessionTimeoutLogout();
  }

  const prevActivityTimestamp = getLastActivityTimestamp(prevState);
  const isCheckTimeoutAction = action.type === CHECK_TIMEOUT;
  const nextActivityTimestamp = isCheckTimeoutAction ? Date.now() : getLastActivityTimestamp(newState);
  if (nextActivityTimestamp > prevActivityTimestamp && !isCheckTimeoutAction) {
    resetSessionTimeoutWarning(store);
    resetSessionTimeoutLogout();
  }

  return result;
};

export default sessionActivity;
